<template>
  <el-dialog :title="editing ? '编辑监测账号' : '添加监测账号'" :visible="visible" width="520px" :close-on-click-modal="!saving" :close-on-press-escape="!saving" :show-close="!saving" @close="close">
    <el-form label-width="100px" :disabled="saving">
      <el-form-item label="平台"><el-select v-model="form.platform" :disabled="!!editing"><el-option label="B站" value="bilibili"/><el-option label="抖音" value="douyin"/><el-option label="视频号" value="wechat_channels"/><el-option label="公众号" value="wechat_mp"/></el-select></el-form-item>
      <el-form-item :label="homepageLabel"><el-input v-model.trim="form.homepage_url" :placeholder="homepagePlaceholder"/></el-form-item>
      <el-form-item label="账号 ID"><el-input v-model.trim="form.account_id" :placeholder="accountIdPlaceholder"/></el-form-item>
      <el-form-item label="显示名称"><el-input v-model.trim="form.account_name" placeholder="可选，方便页面识别"/></el-form-item>
      <el-form-item label="自动同步"><el-switch v-model="form.enabled"/></el-form-item>
    </el-form>
    <div class="hint">{{ accountHint }}</div>
    <span slot="footer"><el-button :disabled="saving" @click="close">取消</el-button><el-button type="primary" :loading="saving" @click="save">{{saving?'保存中':'保存'}}</el-button></span>
  </el-dialog>
</template>

<script>
import { yuqingApi } from '@/api/yuqing'
const empty = () => ({ platform: 'bilibili', homepage_url: '', account_id: '', account_name: '', enabled: true })
export default {
  props: ['visible', 'editing'], data () { return { form: empty(), saving: false } },
  computed: {
    homepageLabel () { return this.form.platform === 'wechat_mp' ? '公众号文章' : '账号主页' },
    homepagePlaceholder () {
      if (this.form.platform === 'wechat_channels') return '粘贴视频号主页或识别来源链接'
      if (this.form.platform === 'wechat_mp') return '粘贴任意一篇该公众号的文章链接'
      return '粘贴 B站 UP 主或抖音作者主页链接'
    },
    accountIdPlaceholder () {
      if (this.form.platform === 'wechat_channels') return '必填：TikHub finder username（v2_...@finder）'
      if (this.form.platform === 'wechat_mp') return '可不填，系统从文章链接识别 gh_username'
      return '无法从链接识别时再填写'
    },
    accountHint () {
      if (this.form.platform === 'wechat_channels') return '视频号通过 TikHub 同步作品 object_id，用于采集作品评论。'
      if (this.form.platform === 'wechat_mp') return '系统会从文章链接识别公众号，自动发现新增文章，并采集阅读、点赞、在看、分享/转发、收藏、评论和星标。数据源暂不提供曝光量和播放量。'
      return '添加后系统每天自动发现新增作品，并刷新该平台全部已入库作品的公开指标。'
    }
  },
  watch: { visible (v) { if (v) this.form = this.editing ? { ...this.editing } : empty() } },
  methods: {
    close () { if (!this.saving) this.$emit('update:visible', false) },
    async save () {
      if (this.saving) return
      if (!this.form.homepage_url) return this.$message.warning('请填写账号主页链接')
      if (this.form.platform === 'wechat_channels' && !/^v2_[0-9a-f]+@finder$/i.test(this.form.account_id || '')) return this.$message.warning('请填写正确的视频号 finder username（v2_...@finder）')
      if (this.form.platform === 'wechat_mp' && !/^https:\/\/mp\.weixin\.qq\.com\//i.test(this.form.homepage_url)) return this.$message.warning('请粘贴正确的公众号文章链接')
      if (this.form.platform === 'wechat_mp' && this.form.account_id && !/^gh_[0-9a-z]+$/i.test(this.form.account_id)) return this.$message.warning('公众号账号 ID 应为 gh_ 开头的 gh_username')
      this.saving = true
      try {
        if (this.editing) await yuqingApi.put(`creator-accounts/${this.editing.id}`, this.form)
        else await yuqingApi.post('creator-accounts', this.form)
        this.$message.success('监测账号已保存')
        this.saving = false
        this.close()
        this.$emit('success')
      } catch (e) {
        this.$message.error(e.message || '账号保存失败')
      } finally {
        this.saving = false
      }
    }
  }
}
</script>

<style scoped>.hint { color: #909399; line-height: 20px; margin-left: 20px }</style>
